import { create } from "zustand";
import axios from "axios";

export const useStore = create((set, get) => ({
  ip: "",
  poster: "",
  cRefer: "",
  portal: "C22ABSY", // default portal
  pathname: "",

  navData: [],
  siteData: [],
  sectionData: null,
  productData: [],
  categoryData: [],
  loading: false,
  error: null,

  user: null,

  setUser: (user) => {
    set({ user });
    localStorage.setItem("user", JSON.stringify(user));
  },

  clearUser: () => {
    set({ user: null });
    localStorage.removeItem("user");
    sessionStorage.removeItem("session_id");
  },

  setPathname: (url) => set({ pathname: url }),

  getDeviceIP: async () => {
    try {
      const response = await axios.get("https://geolocation-db.com/json/");
      set({ ip: response?.data?.IPv4 });
    } catch (error) {
      console.error("Error fetching IP:", error);
    }
  },

  fetchNavData: async () => {
    try {
      const response = await axios.get(
        `https://ghorami.com/customer_manager/crm_bw_gate.php?request_type=Get_Page&portal=${get().portal}`
      );
      set({ navData: response.data });
    } catch (error) {
      console.error("Error fetching nav data:", error);
    }
  },

  fetchSectionData: async () => {
    try {
      const response = await axios.get(
        `https://ghorami.com/customer_manager/crm_bw_gate.php?request_type=Get_PageDetails&item_refer=${get().pathname}&portal=${get().portal}`
      );
      set({ sectionData: response.data[0] });
    } catch (error) {
      console.error("Error fetching section data:", error);
    }
  },

  fetchSiteData: async () => {
    try {
      const response = await axios.get(
        `https://ghorami.com/customer_manager/crm_bw_gate.php?request_type=Get_Intro&portal=${get().portal}`
      );
      set({ siteData: response.data });
    } catch (error) {
      console.error("Error fetching site data:", error);
    }
  },

  getCategories: async () => {
    try {
      const response = await axios.get(
        `https://aps.songjukti.com/customer_manager/crm_bw.php?request_type=Get_ItemCategory&portal=${get().portal}&item=productSet&SopnoID=ZD7N4AP&item_refer=${get().portal}&p1=productSet&p2=category&p3=1&date=`
      );
      set({ categoryData: response.data });
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  },

  fetchProductData: async () => {
    try {
      const response = await axios.get(
        `https://ghorami.com/customer_manager/crm_bw_gate.php?request_type=Get_ItemDetails&portal=${get().portal}&item=Product&SopnoID=ZD7N4AP&item_refer=&request_state=all&page=1&period=&date=`
      );
      set({ productData: response.data });
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  },
}));
